(() => {
	let e = (e) => {
			if (!e.open || e.classList.contains(`is-closing`)) return;
			let t = e.closest(`.site-header__locale, .site-footer__locale`),
				n = window.matchMedia?.(`(prefers-reduced-motion: reduce)`).matches;
			if (!t || n) {
				e.open = !1;
				return;
			}
			e.classList.add(`is-closing`),
				window.setTimeout(() => {
					(e.open = !1), e.classList.remove(`is-closing`);
				}, 340);
		},
		t = (t = null) => {
			document.querySelectorAll(`[data-country-selector]`).forEach((n) => {
				if (n === t) return;
				let r = n.querySelector(`details`);
				r && e(r);
			});
		},
		n = (n) => {
			if (n.dataset.countrySelectorReady === `true`) return;
			n.dataset.countrySelectorReady = `true`;
			let r = n.querySelector(`form`),
				i = n.querySelector(`details`),
				a = n.querySelector(`[data-country-selector-country]`),
				o = n.querySelector(`[data-country-selector-language]`);
			!r ||
				!i ||
				!a ||
				!o ||
				(i.querySelector(`summary`)?.addEventListener(`click`, (t) => {
					i.open && (t.preventDefault(), e(i));
				}),
				i.addEventListener(`toggle`, () => {
					i.open && (i.classList.remove(`is-closing`), t(n));
				}),
				n.querySelectorAll(`[data-country-selector-option]`).forEach((e) => {
					e.addEventListener(`click`, () => {
						let t = e.getAttribute(`data-country-code`),
							n = e.getAttribute(`data-language-code`);
						!t || !n || ((a.value = t), (o.value = n), r.submit());
					});
				}));
		};
	document.querySelectorAll(`[data-country-selector]`).forEach((e) => {
		n(e);
	}),
		document.addEventListener(`click`, (e) => {
			let n = e.target;
			n instanceof Element && (n.closest(`[data-country-selector]`) || t());
		}),
		document.addEventListener(`keydown`, (e) => {
			e.key === `Escape` && t();
		});
})();
